var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.archiveMenu)?_c('MenuArchive',{on:{"homePage":_vm.homePage}}):(_vm.atlasMenu)?_c('MenuAtlas',{on:{"homePage":_vm.homePage}}):_c('MenuGU',{on:{"navigate":_vm.navigateTo}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }